<template>
<v-container fluid>
    <tracking-skeleton @copyOpen="copyOpen" @mailOpen="mailOpen" :saving="saving" @save="save" v-model="open" :fails.sync="fails" platform="OTHER">
        <template v-slot:platformSettings>
                        <div style="max-width:800px">
                        <v-text-field
                            id="pfid1618851296"  
                            :label="$t('tracking.other.imageClass')"
                            class="pr-3"
                            v-model="imageClass"
                        />
                        <v-text-field 
                            id="pfid1618851304" 
                            :label="$t('tracking.other.imageId')"
                            class="pr-3"
                            v-model="imageId"
                            
                        />
                        </div>
        </template>
        <template v-slot:tracker="{ id }">
            <p id="instructions-tracker" v-html="$t('tracking.other.tracker[0]')"></p>
            <p id="instructions-tracker" v-html="$t('tracking.other.tracker[1]')"></p>
            <p id="instructions-tracker" v-html="$t('tracking.other.tracker[2]')"></p>
            <code-block language="html" :code="code.tracker.replace('%droiid%', id)" />
<!--
<code-block language="html">
    <pre>
&lt;script defer src="../../public/client/dreamroi.js"&gt;&lt;/script&gt;
&lt;script&gt;
  window.addEventListener('DOMContentLoaded', function() { roi.init('{{ id }}') });
&lt;/script&gt;
</pre>

</code-block>
-->
        </template>
        <template v-slot:viewProduct>
            <p id="instructions-viewProduct" v-html="$t('tracking.other.product')"></p>

            <code-block language="html" :code="code.viewProduct" />
        </template>
        <template v-slot:signIn>
            <p id="instructions-signIn" v-html="$t('tracking.other.signIn')"></p>

            <code-block language="html" :code="code.signIn" />
        </template>
        <template v-slot:addToCart>
            <p id="instructions-addToCart" v-html="$t('tracking.other.addToCart')"></p>

            <code-block language="html" :code="code.addToCart" />
        </template>
        <template v-slot:purchase>
            <div id="instructions-purchase">
            <p v-html="$t('tracking.other.purchase[0]')"></p>
            <ul class="mb-2">
                <li v-html="$t('tracking.other.purchase[1]')"></li>
                <li v-html="$t('tracking.other.purchase[2]')"></li>
                <li v-html="$t('tracking.other.purchase[3]')"></li>
                <li v-html="$t('tracking.other.purchase[4]')"></li>
            </ul>
            <p v-html="$t('tracking.other.purchase[5]')"></p>
            <p v-html="$t('tracking.other.purchase[6]')"></p>
            </div>
            <code-block language="html" :code="code.purchase" />
        </template>
    </tracking-skeleton>
</v-container>
</template>
<script>

import { mapGetters } from 'vuex'

import TrackingSkeleton from '@/components/TrackingSkeleton'
import CodeBlock from '@/components/CodeBlock'
import EntityForm from '@/mixins/entity-form'
import Wizards from '@/mixins/wizards'
import PanelOpener from "@/mixins/panel-opener"

export default {
    name: 'TrackingOther',
    mixins: [EntityForm, Wizards, PanelOpener],
    components: { TrackingSkeleton, CodeBlock },
    data() {
        return {
            endpoint: 'domains',
            imageClass: null,
            imageId: null,
            fields: {
                leadscoringSettings: null
            }
        }
    },
    computed: {
        code() {
            return {
                tracker: 
`&lt;!-- The dreamroi-consent.js script is used together with cookie management platforms such as CookieBot. --&gt;
 &lt;script defer src="${this.baseUrl}/client/v1/dreamroi-consent.js"&gt;&lt;/script&gt; 
 &lt;script defer src="${this.baseUrl}/client/v1/dreamroi.min.js"&gt;&lt;/script&gt;
 &lt;script&gt;
   window.addEventListener('DOMContentLoaded', function() { 
       /* This is an alternative method of indicating personalization cookies consent
       roi.setConsent(%boolValue%);
       */
       roi.init('%droiid%') 
    });
 &lt;/script&gt;
`, 
viewProduct:`&lt;script&gt;
  window.addEventListener('DOMContentLoaded', function() {roi.viewProduct('%id%')});
 &lt;/script&gt;
`,
signIn:`&lt;script&gt;
   window.addEventListener('DOMContentLoaded', function() { roi.signIn('%useremail%') });
 &lt;/script&gt; `,
addToCart:`&lt;script&gt;
   window.addEventListener('DOMContentLoaded', function() { roi.addToCart(%productIds%) });
 &lt;/script&gt; `,
purchase:`&lt;script&gt;
   window.addEventListener('DOMContentLoaded', function() { 
     roi.purchase(
        {
            id: 1234, 
            email: '%useremail%', 
            total: 5, 
            items: [
                { id: %orderId%, quantity: %quantity%, price: %price%}
            ]
        }
     )
   });
 &lt;/script&gt; `,
callback:`
// using callback
roi.purchase(
    order,
    function (err) {
        console.log(err ? \`DreamROI errror: \${err}\` : 'The data were sent to DreamROI.')
    }
);

// using promise
roi.promises.purchase(order).then(function(err) { console.log(err ? \`DreamROI errror: \${err}\` : 'The data were sent to DreamROI.') })
`
            }
        },
        
        ...mapGetters('ui', ['baseUrl'])
    },
    methods: {
        afterFieldsLoad() {
            this.imageClass = this.item.leadscoringSettings.imageClass;
            this.imageId = this.item.leadscoringSettings.imageId;
        },
        prepareFields() {
            this.fields.leadscoringSettings.imageClass = this.imageClass;
            this.fields.leadscoringSettings.imageId = this.imageId;
        }
    }
}
</script>